import { render, staticRenderFns } from "./argumentsList.vue?vue&type=template&id=cedbd636&scoped=true&"
import script from "./argumentsList.vue?vue&type=script&lang=js&"
export * from "./argumentsList.vue?vue&type=script&lang=js&"
import style0 from "./argumentsList.vue?vue&type=style&index=0&id=cedbd636&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cedbd636",
  null
  
)

export default component.exports